/* RebootDeviceRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;

class RebootDeviceRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("run-screen-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;

        this._titleText = document.createElement("h3");
        this._titleText.innerHTML = "Reboot Devices";

        this._deviceTitleInput = new InputTextControl({
            darkTheme: true,
            value: "Device Reboot - " + new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString()
        });
        this._buttonBarElem = document.createElement("button-container");
        this._buttonBarElem.classList.add("button-bar");

        this._scheduleDevice = new ButtonControl({
            label: "Schedule Reboot",
            darkTheme: true
        });
        this._startDevice = new ButtonControl({
            label: "Start Reboot",
            darkTheme: true
        });
        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true
        });
        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._scheduleDevice.on("UserClick", this._onScheduleDeviceAction.bind(this));
        this._startDevice.on("UserClick", this._onStartDeviceAction.bind(this));
        this._cancelButton.on("UserClick", this._cancelAction.bind(this));
    }

    _unregisterListeners() {
        this._scheduleDevice.removeListener("UserClick", this._onScheduleDeviceAction);
        this._startDevice.removeListener("UserClick", this._onStartDeviceAction);
        this._cancelButton.removeListener("UserClick", this._cancelAction.bind(this));
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();

        let promArr = [this._deviceTitleInput.shutdown, this._scheduleDevice.shutdown, this._startDevice.shutdown, this._cancelButton.shutdown];

        return Promise.all(promArr).then(
            () => {
                this._titleText.remove();
                this._titleText = undefined;
                this._deviceTitleInput = undefined;
                this._buttonBarElem.remove();
                this._scheduleDevice = undefined;
                this._startDevice = undefined;
                this._cancelButton = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "RebootDeviceRenderer.shutdown() error.");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleText);
                this._rootElem.appendChild(this._deviceTitleInput.renderer.rootElement);
                this._buttonBarElem.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonBarElem.appendChild(this._scheduleDevice.renderer.rootElement);
                this._buttonBarElem.appendChild(this._startDevice.renderer.rootElement);
                this._rootElem.appendChild(this._buttonBarElem);
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/
    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _onScheduleDeviceAction() {
        const workInput = this._getWorkInput();
        return this._model.scheduleDevice(workInput);
    }

    _onStartDeviceAction() {
        const workInput = this._getWorkInput();
        this._model.startDevice(workInput);
    }
    _cancelAction() {
        this._model.cancelReboot();
    }
    _getWorkInput() {
        return {
            description: this._deviceTitleInput.value
                ? this._deviceTitleInput.value
                : "Device Reboot - " + new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString()
        };
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = RebootDeviceRenderer;
